/**************************************************
 * Nombre:       Apartado_Razones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../../Recursos/Temporales/img_razones.png'
import {theme} from "../../Tema";
import {CheckCircle} from '@mui/icons-material'
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";


const Apartado_Razones = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >

            <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <img src={fondo} width={'100%'} height={'auto'} alt={'fondo'}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 6, md: 6}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{color: theme.palette.primary.main, fontSize: 14}}>Razones</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 0 : 1}}>
                    <Typography sx={{fontSize: 20, fontWeight: 700, lineHeight: 1.2}}>
                        7 Razones para Impulsar tu Crecimiento con Nebo System y Nipponflex
                    </Typography>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{mt: 1}}
                    spacing={0}
                >

                    {items.map((item, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{mt: 0.5}}>
                                <CheckCircle
                                    sx={{
                                        fill: theme.palette.primary.main,
                                        width: 16,
                                        height: 16,
                                        mt: 0.3,
                                        mb: -0.3,
                                        pr: 1
                                    }}/>
                                {item}
                            </Typography>
                        </Grid>
                    ))}

                </Grid>


            </Grid>


        </Grid>
    )

}
export default Apartado_Razones

const items = [
    'Sinergia entre tecnología de vanguardia y bienestar corporativo',
    'Optimización de procesos de prospección (High-Ticket)',
    'Modelo de negocio sin barreras operativas tradicionales',
    'Soporte y acompañamiento estructurado',
    'Ecosistema visual y de marca profesional',
    'Plan de carrera y escalabilidad de ingresos',
    'Capacitación constante en neuroventas y tecnología'

]